import CookieUtils from 'utils/CookieUtils'
import conf from 'conf'

function genereateVersionValue(specification) {
  let j = 0
  const table = []

  Object.keys(specification).forEach((item) => {
    for (j = 0; j < specification[`${item}`] * 10; j++) {
      table.push(item)
    }
  })

  return table[Math.floor(Math.random() * table.length)]
}

class ABTestUtils {
  static getTestVersion(cookieName) {
    const cookieLifetime = 21
    if (cookieName === '') {
      return 'control'
    }

    const cookie = CookieUtils.getCookie(cookieName)

    if (cookie === 'control' || cookie === 'test') {
      return cookie
    }

    const versionValue = genereateVersionValue({
      control: conf.eHorizonVersionA,
      test: conf.eHorizonVersionB
    })
    CookieUtils.setCookie(cookieName, versionValue, cookieLifetime)

    return versionValue
  }

  static isNewVersionEnabled() {
    return true
  }
}

export default ABTestUtils
